import * as React from 'react';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ComponentProps } from 'ui/common';

interface FactItemConnectedCasesProps extends ComponentProps, FactItemProps {
  connectedCasesIds: number[];
  [key: string]: any;
}

const ConnectedCasesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.628 22.627">
    <defs>
      <style>{`
        .cc-cls-1, .cc-cls-2, .cc-cls-4 { fill: none; }
        .cc-cls-1, .cc-cls-2 { stroke: #000; }
        .cc-cls-1 { stroke-width: 1.5px; }
        .cc-cls-3 { stroke: none; }
      `}</style>
    </defs>
    <g transform="translate(-70.71 -560.028) rotate(45)">
      <g className="cc-cls-1" transform="translate(451 341)">
        <rect className="cc-cls-3" width="10" height="10" rx="2"/>
        <rect className="cc-cls-4" x="0.75" y="0.75" width="8.5" height="8.5" rx="1.25"/>
      </g>
      <g className="cc-cls-1" transform="translate(463 341)">
        <rect className="cc-cls-3" width="10" height="10" rx="2"/>
        <rect className="cc-cls-4" x="0.75" y="0.75" width="8.5" height="8.5" rx="1.25"/>
      </g>
      <g className="cc-cls-2" transform="translate(456 345)">
        <rect className="cc-cls-3" width="12" height="2"/>
        <rect className="cc-cls-4" x="0.5" y="0.5" width="11" height="1"/>
      </g>
    </g>
  </svg>
);

export const ConnectedCasesFactItem = (props: FactItemConnectedCasesProps) => {
  const { tooltip, title, connectedCasesIds, url, linkDomain, portalTarget } = props;
  const iconConnectedCases = <ConnectedCasesIcon />;
  const items = [
    { value: connectedCasesIds?.length, tooltip }
  ];

  if (!connectedCasesIds?.length) {
    return null;
  }  

  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url}
    params={props.params}>
    <BadgeList
      icon={iconConnectedCases}
      title={title}
      valueItems={items}
      portalTarget={portalTarget}
    />
  </FactLink>;
};
